import { Component } from '@theme/component';

/**
 * Indéscents — liste d'avis (section « Avis »).
 * Toutes les cartes sont rendues côté Liquid ; celles au-delà de `data-per-page` portent l'attribut `hidden`.
 * « Voir plus d'avis » révèle le paquet suivant, met à jour le compteur restant, et déplace le focus
 * sur la première carte révélée (navigation clavier / lecteurs d'écran).
 */
class IndescentsAvisList extends Component {
  connectedCallback() {
    super.connectedCallback();
    const parsed = parseInt(this.dataset.perPage || '6', 10);
    this.perPage = Number.isFinite(parsed) && parsed > 0 ? parsed : 6;
    this.cards = Array.from(this.querySelectorAll('[data-card]'));
    this.more = this.querySelector('[data-more]');
    this.remaining = this.querySelector('[data-remaining]');
    this.status = this.querySelector('[data-status]');
    this.onMore = () => this.reveal();
    if (this.more) this.more.addEventListener('click', this.onMore);
    this.update();
  }

  disconnectedCallback() {
    if (this.more) this.more.removeEventListener('click', this.onMore);
    if (typeof super.disconnectedCallback === 'function') super.disconnectedCallback();
  }

  hiddenCards() {
    return this.cards.filter((card) => card.hidden);
  }

  reveal() {
    const batch = this.hiddenCards().slice(0, this.perPage);
    batch.forEach((card) => {
      card.hidden = false;
    });
    this.update();
    const first = batch[0];
    if (first) {
      first.setAttribute('tabindex', '-1');
      first.focus();
    }
  }

  update() {
    const left = this.hiddenCards().length;
    const shown = this.cards.length - left;
    if (this.remaining) this.remaining.textContent = String(left);
    if (this.more) this.more.hidden = left === 0;
    if (this.status) this.status.textContent = `${shown} avis affichés sur ${this.cards.length}`;
  }
}

if (!customElements.get('indescents-avis-list')) customElements.define('indescents-avis-list', IndescentsAvisList);
